var _defs, _g, _g2, _div, _text, _switch;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUgcanLogoV3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      background: "transparent",
      backgroundColor: "transparent",
      colorScheme: "light dark"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "160px",
    height: "62px",
    viewBox: "-0.5 -0.5 160 62",
    content: "<mxfile host=\"Electron\" agent=\"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/27.0.5 Chrome/134.0.6998.205 Electron/35.3.0 Safari/537.36\" version=\"27.0.5\"> <diagram name=\"Page-1\" id=\"Yv6Wm9FWp_e4e-Tb8ed0\"> <mxGraphModel dx=\"9\" dy=\"32\" grid=\"1\" gridSize=\"10\" guides=\"1\" tooltips=\"1\" connect=\"1\" arrows=\"1\" fold=\"1\" page=\"1\" pageScale=\"1\" pageWidth=\"100\" pageHeight=\"50\" math=\"0\" shadow=\"0\"> <root> <mxCell id=\"0\" /> <mxCell id=\"1\" parent=\"0\" /> <mxCell id=\"bUd7CiduXVbOxkzf574i-3\" value=\"\" style=\"group\" vertex=\"1\" connectable=\"0\" parent=\"1\"> <mxGeometry x=\"440\" y=\"290\" width=\"159.11\" height=\"60\" as=\"geometry\" /> </mxCell> <mxCell id=\"XBhk3FTvXP_LvTU_Q_pj-17\" value=\"\" style=\"rounded=1;whiteSpace=wrap;html=1;arcSize=23;fillColor=#19BA92;strokeColor=#82b366;container=0;\" parent=\"bUd7CiduXVbOxkzf574i-3\" vertex=\"1\"> <mxGeometry width=\"80\" height=\"60\" as=\"geometry\" /> </mxCell> <mxCell id=\"yoEL58Z-uiF5sRoB7llE-2\" value=\"College&lt;div&gt;Avenue&lt;/div&gt;\" style=\"text;html=1;align=center;verticalAlign=bottom;whiteSpace=wrap;rounded=0;fontSize=18;fontFamily=Century Schoolbook;fontSource=https%3A%2F%2Ffonts.googleapis.com%2Fcss%3Ffamily%3DCentury%2BSchoolbook;fillColor=none;fontColor=#19ba92;textShadow=0;glass=0;shadow=0;container=0;fontStyle=1;labelBackgroundColor=default;spacing=0;strokeWidth=0;spacingBottom=0;spacingLeft=0;\" parent=\"bUd7CiduXVbOxkzf574i-3\" vertex=\"1\"> <mxGeometry x=\"77\" width=\"82.11\" height=\"60\" as=\"geometry\" /> </mxCell> <mxCell id=\"j_yM8PVcVNGmFxpFCtzh-11\" value=\"\" style=\"verticalLabelPosition=bottom;verticalAlign=top;html=1;shape=mxgraph.basic.acute_triangle;dx=0.5;strokeColor=none;\" parent=\"bUd7CiduXVbOxkzf574i-3\" vertex=\"1\"> <mxGeometry x=\"35.86999999999995\" y=\"1\" width=\"35\" height=\"30\" as=\"geometry\" /> </mxCell> <mxCell id=\"XBhk3FTvXP_LvTU_Q_pj-5\" value=\"\" style=\"verticalLabelPosition=bottom;verticalAlign=top;html=1;shape=mxgraph.basic.partConcEllipse;startAngle=0.46251185199778944;endAngle=0.05765019810777609;arcWidth=0.46;strokeColor=none;fillColor=#FFFFFF;container=0;rotation=0;\" parent=\"bUd7CiduXVbOxkzf574i-3\" vertex=\"1\"> <mxGeometry x=\"5.8799999999999955\" y=\"10\" width=\"62.22\" height=\"45\" as=\"geometry\" /> </mxCell> <mxCell id=\"XBhk3FTvXP_LvTU_Q_pj-19\" value=\"\" style=\"rounded=1;whiteSpace=wrap;html=1;rotation=0;strokeColor=none;fillColor=#FFFFFF;container=0;\" parent=\"bUd7CiduXVbOxkzf574i-3\" vertex=\"1\"> <mxGeometry x=\"37\" y=\"44.5\" width=\"33\" height=\"10.75\" as=\"geometry\" /> </mxCell> <mxCell id=\"j_yM8PVcVNGmFxpFCtzh-3\" value=\"\" style=\"rounded=0;whiteSpace=wrap;html=1;fillColor=#ffffff;strokeColor=#2D7600;strokeWidth=0;fontSize=10;fontColor=#ffffff;\" parent=\"bUd7CiduXVbOxkzf574i-3\" vertex=\"1\"> <mxGeometry x=\"49.870000000000005\" y=\"34\" width=\"7\" height=\"7\" as=\"geometry\" /> </mxCell> <mxCell id=\"j_yM8PVcVNGmFxpFCtzh-4\" value=\"\" style=\"rounded=0;whiteSpace=wrap;html=1;fillColor=#ffffff;strokeColor=#2D7600;strokeWidth=0;fontSize=10;fontColor=#ffffff;\" parent=\"bUd7CiduXVbOxkzf574i-3\" vertex=\"1\"> <mxGeometry x=\"39.110000000000014\" y=\"34\" width=\"7\" height=\"7\" as=\"geometry\" /> </mxCell> <mxCell id=\"j_yM8PVcVNGmFxpFCtzh-2\" value=\"\" style=\"rounded=0;whiteSpace=wrap;html=1;fillColor=#ffffff;strokeColor=#2D7600;strokeWidth=0;fontSize=10;fontColor=#ffffff;\" parent=\"bUd7CiduXVbOxkzf574i-3\" vertex=\"1\"> <mxGeometry x=\"60\" y=\"34\" width=\"7\" height=\"7\" as=\"geometry\" /> </mxCell> </root> </mxGraphModel> </diagram>\n</mxfile>\n",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 0
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 1
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "bUd7CiduXVbOxkzf574i-3"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "XBhk3FTvXP_LvTU_Q_pj-17"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 80,
    height: 60,
    rx: 13.8,
    ry: 13.8,
    fill: "#19ba92",
    stroke: "#82b366",
    pointerEvents: "all",
    style: {
      fill: "rgb(25, 186, 146)",
      stroke: "rgb(130, 179, 102)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "yoEL58Z-uiF5sRoB7llE-2"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 0,
    width: 82.11,
    height: 60,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-end",
      justifyContent: "unsafe center",
      width: 84,
      height: 1,
      paddingTop: 59,
      marginLeft: 76
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#19ba92",
      backgroundColor: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 18,
      fontFamily: "&quot",
      color: "#19ba92",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      backgroundColor: "#ffffff",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "College", _div || (_div = /*#__PURE__*/React.createElement("div", null, "Avenue")))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 118,
    y: 59,
    fill: "#19ba92,",
    fontFamily: "\"Century Schoolbook\"",
    fontSize: "18px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "College...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "j_yM8PVcVNGmFxpFCtzh-11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 35.87 31 L 53.37 1 L 70.87 31 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "#ffffff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "XBhk3FTvXP_LvTU_Q_pj-5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 44.25 54.38 C 31.26 56.63 17.73 52.64 10.63 44.45 C 3.53 36.26 4.46 25.71 12.93 18.24 C 21.4 10.76 35.52 8.04 48.01 11.46 L 42.94 21.14 C 36.2 19.29 28.57 20.76 24 24.8 C 19.42 28.83 18.92 34.53 22.76 38.95 C 26.59 43.37 33.89 45.53 40.91 44.31 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "XBhk3FTvXP_LvTU_Q_pj-19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 44.5,
    width: 33,
    height: 10.75,
    rx: 1.61,
    ry: 1.61,
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "j_yM8PVcVNGmFxpFCtzh-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 49.87,
    y: 34,
    width: 7,
    height: 7,
    fill: "#ffffff",
    stroke: "#2d7600",
    strokeWidth: 0.1,
    pointerEvents: "all",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(45, 118, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "j_yM8PVcVNGmFxpFCtzh-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.11,
    y: 34,
    width: 7,
    height: 7,
    fill: "#ffffff",
    stroke: "#2d7600",
    strokeWidth: 0.1,
    pointerEvents: "all",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(45, 118, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "j_yM8PVcVNGmFxpFCtzh-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 34,
    width: 7,
    height: 7,
    fill: "#ffffff",
    stroke: "#2d7600",
    strokeWidth: 0.1,
    pointerEvents: "all",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(45, 118, 0)"
    }
  }))))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.drawio.com/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUgcanLogoV3);
export default __webpack_public_path__ + "static/media/ugcan_logo_V3.df71bfdea93f94758b52bc77787efe2d.svg";
export { ForwardRef as ReactComponent };